import { createStore } from 'vuex'
import Cookies from 'js-cookie'

export default createStore({
    state: {
        token: "",
        user: "",
        wallet: ""
    },
    getters: {},
    mutations: {
        VUEX_SET_TOKEN: (state, payload) => {
            state.token = payload;
            Cookies.set('yoni_token', payload, { expires: 1 }); //创建有效期为1天的cookie
        },
        VUEX_SET_USER: (state, payload) => {
            state.user = payload;
            window.localStorage.setItem("user", JSON.stringify(payload))
        },
        VUEX_SET_WALLET: (state, payload) => {
            state.wallet = payload;
            window.localStorage.setItem("wallet", JSON.stringify(payload))
        },
    },
    actions: {},
    modules: {}
})